import React, { Component, PropTypes } from 'react';
import partial from 'lodash/partial';
import ModalDialog from 'common/components/modal/modal_dialog';
import Payment from 'pap/containers/payment';

/**
 * 1-1 project payment modal.
 * It's actually just a modal wrapping PAP's payment step.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const PaymentModal = ({show}) => {
  const close = partial(show, false);
  return (
    <ModalDialog 
      modalOpen={true}
      dialogClasses="payment-modal-1-1"
      closeAction={close}
      modalHeader="Pay for your project"
    >
      <Payment onBack={close} onSuccess={close}/>
    </ModalDialog>)
}

export default PaymentModal;



// WEBPACK FOOTER //
// ./project/components/brief/payment_modal_1_1.jsx